import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';

const elasticCloudContent = EntityContentBlueprint.make({
  name: 'elastic-cloud',
  params: {
    path: '/elastic',
    title: 'Elastic',
    group: 'operation',
    filter: entity =>
      entity.kind.toLocaleLowerCase('en-US') === 'component' &&
      Boolean(entity.metadata.annotations?.['elastic.co/cloud-deployment-id']),
    loader: () =>
      import('./ElasticCloudContent').then(m => <m.ElasticCloudContent />),
  },
});

export const elasticCloudModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [elasticCloudContent],
});
